import { Injectable } from "@angular/core";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class TechBuyerService {
  constructor(private httpClient: HttpClient) {}
  inviteTechBuyer(email: string, userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("emailId", email)
      .append("id", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/tech-buyer-invitation", {
      params: params
    });
  }

  getTechBuyerDetails(id: string) {
    return this.httpClient.get(`users/${id}/profile`);
  }

  updateBuyerDetails(id: string, buyerDetails) {
    return this.httpClient.patch(`users/${id}`, buyerDetails);
  }

  updateBuyerCompanyDetails(id: string, companyDetails) {
    return this.httpClient.patch(
      `TechbuyerOrganizations/user/${id}`,
      companyDetails
    );
  }

  updateSurveyResponse(response: any) {
    return this.httpClient.patch('SurveyResponses', response);
  }

  getOrganizations() {
    return this.httpClient.get("Organizations");
  }

  getSurveyData(filter: any, surveyId: string) {
    return this.httpClient.get(`Surveys/${surveyId}`, { params: filter });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-buyer/shared/services/tech-buyer.service.ts